import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './LoginLayout.css';
import logo from '../../images/common/logo.svg';
//import footerImage from '../../images/common/footer_logo.svg';

function Layout() {
  const { t, i18n } = useTranslation();
  let privacyUrl;
  let termsUrl;
  let eulaUrl;
  let contactUrl;
  if (i18n.language === 'kr') {
    privacyUrl = 'https://www.insignary.com/ko/privacy-statement';
    termsUrl = 'https://www.insignary.com/ko/terms-use';
    eulaUrl = 'https://www.insignary.com/en/eula';
    contactUrl = 'https://www.insignary.com/ko/contact-us';
  } else {
    privacyUrl = 'https://www.insignary.com/en/privacy-statement';
    termsUrl = 'https://www.insignary.com/en/terms-use';
    eulaUrl = 'https://www.insignary.com/en/eula';
    contactUrl = 'https://www.insignary.com/en/contact-us';
  }

  return (
    <div className="login_body">
      <div className="login_wrap login">
        <div className="login_header">
          <div className="box">
            <h1 className="logo"><img src={logo} alt="Login" /></h1>
            <p className="text" style={{ whiteSpace: 'pre-line' }}>
              {t('login.message.logo')}
            </p>
          </div>
        </div>
        <Outlet />
      </div>
      <footer className="footer">
        {/*
        <div className="footer_box">
          <p className="footer_logo">
            <img src={footerImage} alt="footer" />
          </p>
          <p className="text">
            We are building a next generation solution to monitor<br />
              the Open Source supply chain.
          </p>
        </div>
        */}
        <div className="footer_line" />
        <div className="footer_box">
          <div className="footer_menu">
            <a
              href={privacyUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('login.menu.privacy')}
            </a>
            <span className="bar" />
            <a
              href={termsUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('login.menu.terms')}
            </a>
            <span className="bar" />
            <a
              href={eulaUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('login.menu.eula')}
            </a>
            <span className="bar" />
            <a
              href={contactUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              {t('login.menu.contact')}
            </a>
          </div>
          <div className="copyright">
            ©2016. Insignary Inc. All Rights Reserved
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
